import { memoize } from "lodash/function"
import request from "../utils/fetch"

const MAP_STYLE = "mapbox://styles/mytoursapp/cjj6jqp3f1ih52smottpbjkqa"
const ACCESS_TOKEN =
  "pk.eyJ1IjoibXl0b3Vyc2FwcCIsImEiOiJDRUVsckI0In0.-eKUxQLVBgTtyoyhxyFyYQ"
const MAP_PADDING = { top: 20, bottom: 20, left: 20, right: 20 }
const DEFAULT_CENTRE = [175.6082, -40.3523]
export const LAYER_ID = "overlay"

let mapboxgl = null

const getTileData = url => {
  return request(url)
}


export function initTileMap(options, tileJsonUrl) {

  if (!tileJsonUrl) {
    throw new Error("No tile JSON url passed")
  }
  return Promise.all([getTileData(tileJsonUrl), loadMap(options)]).then(
    ([tileData, map]) => {
      const { bounds } = tileData

      if (bounds) {
        const [swLat, swLng, nwLat, nwLng] = bounds
        const boundingBox = [[swLat, swLng], [nwLat, nwLng]]
        map.fitBounds(boundingBox, { padding: MAP_PADDING })
      }

      map.addLayer({
        id: LAYER_ID,
        type: "raster",
        source: {
          type: "raster",
          url: tileJsonUrl,
          tileSize: 256
        }
      })
      return map
    }
  )
}

export function loadMap(options) {
  return new Promise((resolve) => {
    const mapboxgl = getMapBox()
    const map = new mapboxgl.Map({
      style: MAP_STYLE,
      center: DEFAULT_CENTRE,
      zoom: 5,
      ...options
    })
    map.on("load", () => resolve(map))
  })
}

export function getMapBox() {
  if (typeof window === "undefined") {
    throw new Error("getMapBox only works client side")
  }

  if (!mapboxgl) {
    mapboxgl = require("mapbox-gl")
    mapboxgl.accessToken = ACCESS_TOKEN
    global.mapboxgl = mapboxgl
  }

  return mapboxgl
}



// WEBPACK FOOTER //
// ./webapp/scripts/mapBox.js